(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ke-product-reviews-summary"] && !Shopify.designMode) return;
  try {
    (() => {
    const triggers = () => document.querySelectorAll('[data-ke-review-summary]');
    const sync = (details) => {
      triggers().forEach((trigger) => {
        if (trigger.getAttribute('aria-controls') === details.id) {
          trigger.setAttribute('aria-expanded', String(details.open));
        }
      });
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element && event.target.closest('[data-ke-review-summary]');
      if (!trigger) return;
      const details = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!(details instanceof HTMLDetailsElement)) return;
      event.preventDefault();
      details.open = true;
      sync(details);
      const summary = details.querySelector('summary');
      if (summary) summary.focus({ preventScroll: true });
      requestAnimationFrame(() => {
        const target = summary || details;
        window.scrollTo({
          top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - 110),
          behavior: 'instant'
        });
      });
    });
    document.addEventListener('toggle', (event) => {
      if (event.target instanceof HTMLDetailsElement && event.target.classList.contains('ke-product-reviews')) {
        sync(event.target);
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
